const extractPlaySettings = (state) => state?.playSettings || [];

export const getPlaySettingByStream = (currentState, targetStreamName) => {
	const playSettings = extractPlaySettings(currentState);

	const matchingSetting = playSettings
		? playSettings.find((setting) => setting.streamName === targetStreamName)
		: undefined;

	return matchingSetting || undefined;
};

export const getPlaySettingsByStreamAndValue = (currentState, targetStreamName, targetPropertyValue) => {
	const playSettings = extractPlaySettings(currentState);

	const matchingSetting = playSettings
		? playSettings.find((setting) => setting.streamName === targetStreamName)
		: undefined;

	if (matchingSetting) {
		const propertyValue = matchingSetting[targetPropertyValue];

		if (propertyValue !== undefined) {
			return propertyValue;
		} else {
			return false; // Return false if the specified property is not found in the setting
		}
	} else {
		return false; // Return false if no matching setting is found for the given stream name
	}
};
